import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ["Rebuilding Monday's session from scratch on Sunday night", 'Running the same three drills until the group gets bored', 'Beginners and experienced players on one court, and no plan that works for both', 'Half the group queuing for a court while a few players hit', 'Not knowing what to teach first, or what comes after the serve', 'Feet in the wrong place for every shot, and no cue that fixes it', 'Scrolling YouTube at 11pm for drills you can actually run with a group', 'Coaching a group when nobody ever coached you'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-night" data-id="element-197" data-mp="1bqcq1mxrvata">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-198" data-mp="17paqf4zy0wqs">
        <div className="text-center" data-id="element-199" data-mp="363viwjguy589">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-shuttle" data-id="element-200" data-mp="362ua6lnbdutp">
            The coaching reality
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold text-white text-[28px] sm:text-4xl md:text-5xl leading-tight tracking-tight" data-id="element-201" data-mp="3205y853b07si">
            If you coach badminton, you know at least{' '}
            <span className="text-coral-soft" data-id="element-202" data-mp="378x02ofjz0ux">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-203" data-mp="3b9gyrwfrycj6">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-night-line bg-night-card px-4 py-4 text-sm text-white/85" data-id="element-204" data-mp="2txazcxvhmbi">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-coral/20" data-id="element-205" data-mp="3q7svu4727nav">
                <XIcon className="h-3 w-3 text-coral-soft" aria-hidden="true" data-id="element-206" data-mp="3u7t93lif9sgc" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display font-bold text-xl sm:text-3xl text-shuttle leading-tight" data-id="element-207" data-mp="qjrn1sadb6up">
          How many more sessions do you want to improvise?
        </p>
      </div>
    </section>;
}